//For complete input validations
export const FULL_POSTAL_CODE_REGEX = /^\d{3}\s?\d{2}$/
